import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from '../../../vars/breakpoints';
/* import gutters from '../../../vars/gutters'; */
import colors from '../../../vars/colors';

export const Title = styled.div`
    display: inline-block;
    font-family: 'OneDot';
    font-size: 25px;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: ${colors['peacock-blue']};
    border-bottom: solid 15px ${colors['white-two']};
    margin-bottom: 100px;
`;


export const MapEdge = styled.div`
    position: absolute;
    pointer-events: none;
    ${ props => props.left && css`        
        left: 0;
        top: 0;
        bottom: 0;
        width: 120px;
        background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.05) 10%, rgba(255, 255, 255, 1) 90%, rgba(255, 255, 255, 1));
        @media (max-width: ${breakpoints['bp-mobile']}) {
            width: 40px;
        }
    `}
    ${ props => props.top && css`        
        left: 0;
        top: 0;
        right: 0;
        height: 120px;
        background: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.05) 10%, rgba(255, 255, 255, 1) 90%, rgba(255, 255, 255, 1));
        @media (max-width: ${breakpoints['bp-mobile']}) {
            height: 40px;
        }
    `}
    ${ props => props.right && css`        
        right: 0;
        top: 0;
        bottom: 0;
        width: 120px;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.05) 10%, rgba(255, 255, 255, 1) 90%, rgba(255, 255, 255, 1));
        @media (max-width: ${breakpoints['bp-mobile']}) {
            width: 40px;
        }
    `}
    ${ props => props.bottom && css`        
        left: 0;
        right: 0;
        bottom: 0;
        height: 120px;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.05) 10%, rgba(255, 255, 255, 1) 90%, rgba(255, 255, 255, 1));
        @media (max-width: ${breakpoints['bp-mobile']}) {
            height: 40px;
        }
    `}
`;

export const PotholeMapWrapper = styled.div`
`;


// WEBPACK FOOTER //
// ./src/components/modules/PotholeMap/styled-components.js